// Module
var code = "<div class=\"{{class}}\" id=\"{{id}}\"> <div class=\"login-other\"> <div class=\"data-form list-social\"> <div class=\"active-login\"></div> <div class=\"or hide\"> <div class=\"border-prefix\"></div><span>Or</span> <div class=\"border-prefix\"></div> </div> <div class=\"other-login\"></div> </div> </div> </div>";
// Exports
module.exports = code;